import React from 'react';
import { Box, Skeleton, Grid, Container } from '@mui/material';
import { styled } from '@mui/material/styles';

const SkeletonCard = styled(Box)(({ theme }) => ({
  background: 'rgba(255, 255, 255, 0.1)',
  backdropFilter: 'blur(10px)',
  borderRadius: theme.shape.borderRadius * 2,
  padding: theme.spacing(3),
  height: '100%',
}));

const HomePageSkeleton = () => {
  return (
    <Container maxWidth="xl">
      {/* Title Skeleton */}
      <Skeleton variant="text" width={300} height={48} sx={{ mb: 4 }} />

      {/* Stats Cards Skeleton */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {[1, 2, 3].map((item) => (
          <Grid item xs={12} md={4} key={item}>
            <SkeletonCard>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <Skeleton variant="circular" width={24} height={24} />
                <Skeleton variant="text" width={100} />
              </Box>
              <Skeleton variant="text" width="60%" height={48} sx={{ mb: 2 }} />
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Skeleton variant="text" width={100} />
                <Skeleton variant="text" width={80} />
              </Box>
            </SkeletonCard>
          </Grid>
        ))}
      </Grid>

      {/* Chart Section Skeleton */}
      <SkeletonCard sx={{ mb: 3 }}>
        <Skeleton variant="text" width={200} height={32} sx={{ mb: 3 }} />
        <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
          <Skeleton variant="rounded" width={100} height={36} />
          <Skeleton variant="rounded" width={100} height={36} />
          <Skeleton variant="rounded" width={120} height={36} />
        </Box>
        <Skeleton variant="rectangular" height={400} />
      </SkeletonCard>

      {/* Transactions Section Skeleton */}
      <SkeletonCard sx={{ mb: 3 }}>
        <Skeleton variant="text" width={200} height={32} sx={{ mb: 3 }} />
        <Box sx={{ mb: 3 }}>
          <Skeleton variant="rounded" width={120} height={36} />
        </Box>
        {[1, 2, 3, 4].map((item) => (
          <Box
            key={item}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              mb: 2,
              p: 1,
            }}
          >
            <Skeleton variant="text" width={50} />
            <Skeleton variant="text" width={150} />
            <Skeleton variant="text" width={100} />
            <Skeleton variant="text" width={100} />
            <Skeleton variant="rounded" width={80} height={24} />
          </Box>
        ))}
      </SkeletonCard>

      {/* Portfolio Distribution Skeleton */}
      <SkeletonCard>
        <Skeleton variant="text" width={250} height={32} sx={{ mb: 3 }} />
        <Box sx={{ mb: 3 }}>
          <Skeleton variant="rounded" width={120} height={36} />
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Skeleton variant="circular" width={300} height={300} />
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ p: 2 }}>
              <Skeleton variant="text" width={200} height={32} sx={{ mb: 3 }} />
              {[1, 2].map((item) => (
                <Box
                  key={item}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2,
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Skeleton variant="circular" width={12} height={12} />
                    <Skeleton variant="text" width={100} />
                  </Box>
                  <Skeleton variant="text" width={80} />
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>
      </SkeletonCard>
    </Container>
  );
};

export default HomePageSkeleton;